import { render, staticRenderFns } from "./OfferLinkGroupListOption.vue?vue&type=template&id=5f2d215d"
import script from "./OfferLinkGroupListOption.vue?vue&type=script&lang=js"
export * from "./OfferLinkGroupListOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports